export const PRODUCT_HEADER_HEIGHT = 58;
export const PRODUCT_STICKY_HEIGHT_CLASS =
  'h-[calc(100dvh-58px)] max-h-[calc(100dvh-58px)]';
export const PRODUCT_STICKY_TOP_CLASS = 'top-[58px]';
